import useSWR from "swr";
import { categoriesService } from "../../api_client";
import type { CategoryDto } from "../../../api";

export function useCategories(enabled: boolean = true) {
    return useSWR<CategoryDto[]>(
        enabled ? "categories" : null,
        async () => {
            const response = await categoriesService.getCategories();
            return response.data;
        },
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            refreshInterval: 0,
        },
    );
}

